import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import Navbar from "components/Navbars/Navbar.js";
// import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import Login from "components/login.component";

import routes from "routes.js";

import styles from "assets/jss/material-dashboard-react/layouts/adminStyle.js";

import bgImage from "assets/img/sugarcane.jpg";
import logo from "assets/img/banner_ocsb.png";
import "./admin.css";
import DetailsForFarmer from "./DetailsForFarmer";
import DetailsForMaster from "./DetailsForMaster";

// import authHeader from "services/auth-header";
// console.log(authHeader());

let ps;
// const userpath = [`/admin`, `/staff`];
// const user = JSON.parse(sessionStorage.getItem("user"));
// const Upath = userpath[user.user.member_type]

let userPath;
// const pageLogin = (
//   <Switch>
//     <Route path={"/login"} component={Login} />
//   </Switch>
// );

const useStyles = makeStyles(styles);

export default function Admin({ ...rest }) {
  if (!sessionStorage.getItem("user") || routes.length == 0) {
    return (
      <>
        <Switch>
          <Route path="/check-master/:id" component={DetailsForMaster} />
          <Route path="/check-regsugarcane/:id" component={DetailsForFarmer} />
          <Route path="/login" component={Login} />
          <Redirect from="" to="/login" />
        </Switch>
        {/* <Login /> */}
      </>
    );
  }
  const switchRoutes = (
    <Switch>
      <Route path="/check-master/:id" component={DetailsForMaster} />
      <Route path="/check-regsugarcane/:id" component={DetailsForFarmer} />
      {routes.map((prop, key) => {
        // if (prop.layout === "/staff") {
        //   return (
        //     <Route
        //       path={prop.layout + prop.path}
        //       component={prop.component}
        //       key={key}
        //     />
        //   );
        // }
        // return null;
        userPath = prop.layout;
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      })}
      {userPath == "/ocsbsearch" ? (
        <>
          <Redirect from={userPath} to={userPath + "/search"} />
          <Redirect from="/" to={userPath + "/search"} />
        </>
      ) : (
        <>
          <Redirect from={userPath} to={userPath + "/dashboard"} />
          <Redirect from="/" to={userPath + "/dashboard"} />
        </>
      )}
    </Switch>
  );

  // styles
  const classes = useStyles();
  // ref to help us initialize PerfectScrollbar on windows devices
  const mainPanel = React.createRef();
  // states and functions
  // const [image, setImage] = React.useState(bgImage);
  // const [color, setColor] = React.useState("blue");
  // const [fixedClasses, setFixedClasses] = React.useState("dropdown show");
  const image = bgImage;
  const color = "purple";
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [routeName, setRouteName] = React.useState("");
  const getRouteName = (name) => {
    setRouteName(name);
  };
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  // const getRoute = () => {
  //   return window.location.pathname !== "/admin/maps";
  // };
  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };
  // initialize and destroy the PerfectScrollbar plugin
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", resizeFunction);
    // Specify how to clean up after this effect:
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
      window.removeEventListener("resize", resizeFunction);
    };
  }, [mainPanel]);
  return (
    <div className={classes.wrapper}>
      <Sidebar
        getRouteName={getRouteName}
        routes={routes}
        logoText={""}
        logo={logo}
        image={image}
        handleDrawerToggle={handleDrawerToggle}
        open={mobileOpen}
        color={color}
        {...rest}
      />
      <div className={classes.mainPanel} ref={mainPanel}>
        <Navbar
          routes={routes}
          handleDrawerToggle={handleDrawerToggle}
          {...rest}
          routeName={routeName}
        />
        <div className={classes.content}>
          <div className={classes.container}>{switchRoutes}</div>
        </div>

        {/* On the /maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
        {/* {getRoute() ? (
          <div className={classes.content}>
            <div className={classes.container}>{switchRoutes}</div>
          </div>
        ) : (
          <div className={classes.map}>{switchRoutes}</div>
        )} */}
        {/* {getRoute() ? <Footer /> : null} */}
      </div>
    </div>
  );
}
